(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hfb-bundle-builder"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hfb-bundle-builder')) {
    customElements.define('hfb-bundle-builder', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.variants = JSON.parse(this.querySelector('[data-hfb-variants]').textContent).map(variant => ({
          ...variant, scents: variant.value.split(' + ')
        }));
        this.form = this.querySelector('form');
        this.idInput = this.form.querySelector('input[name="id"]');
        this.button = this.form.querySelector('button[type="submit"]');
        this.status = this.querySelector('[data-hfb-status]');
        this.picks = [...this.querySelectorAll('[data-hfb-pick]')];
        this.picks.forEach(pick => pick.addEventListener('change', () => this.update(), { signal }));
        this.form.addEventListener('submit', event => {
          this.update();
          if (!this.idInput.value || this.button.disabled) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        }, { capture: true, signal });
        this.observer = new MutationObserver(() => this.update());
        this.observer.observe(this.button, { attributes: true, attributeFilter: ['aria-busy'] });
        this.update();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
      }
      canComplete(chosen) {
        return this.variants.some(variant => {
          if (!variant.available) return false;
          const remaining = [...variant.scents];
          return chosen.filter(Boolean).every(scent => {
            const index = remaining.indexOf(scent);
            if (index === -1) return false;
            remaining.splice(index, 1);
            return true;
          });
        });
      }
      update() {
        const chosen = this.picks.map(pick => pick.value);
        const missing = chosen.some(value => !value);
        const hasStock = this.variants.some(variant => variant.available);
        const busy = this.button.getAttribute('aria-busy') === 'true';
        const key = [...chosen].sort().join(' + ');
        const match = missing ? null : this.variants.find(variant => [...variant.scents].sort().join(' + ') === key);
        this.idInput.value = match?.available ? match.id : '';
        this.button.disabled = busy || !this.idInput.value;
        this.picks.forEach((pick, index) => {
          pick.disabled = busy || !hasStock;
          [...pick.options].forEach(option => {
            option.disabled = !option.value || !this.canComplete(chosen.map((value, i) => i === index ? option.value : value));
          });
        });
        this.status.textContent = !hasStock ? this.dataset.soldOut
          : missing ? this.dataset.incomplete
          : !match?.available ? this.dataset.unavailable
          : `${this.dataset.selection} ${chosen.join(', ')}`;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hfb-bundle-tiles"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hfb-bundle-tiles')) {
    customElements.define('hfb-bundle-tiles', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.count = Number(this.dataset.count);
        this.picks = [];
        this.variants = JSON.parse(this.querySelector('[data-hfb-variants]').textContent)
          .map(v => ({ ...v, key: v.value.split(' + ').sort().join(' + ') }));
        this.anyStock = this.variants.some(v => v.available);
        this.form = this.querySelector('form');
        this.idInput = this.form.querySelector('input[name="id"]');
        this.button = this.form.querySelector('button[type="submit"]');
        this.rows = [...this.querySelectorAll('[data-hfb-scent]')];
        this.slots = [...this.querySelectorAll('[data-hfb-slot]')];
        this.rows.forEach(row => {
          const scent = row.dataset.hfbScent;
          row.querySelector('[data-hfb-add]').addEventListener('click', () => this.add(scent), { signal });
          row.querySelector('[data-hfb-plus]').addEventListener('click', () => this.add(scent), { signal });
          row.querySelector('[data-hfb-minus]').addEventListener('click', () => this.remove(this.picks.lastIndexOf(scent)), { signal });
        });
        this.slots.forEach((slot, i) => slot.addEventListener('click', () => this.remove(i), { signal }));
        this.form.addEventListener('submit', event => {
          this.update();
          if (!this.idInput.value || this.button.disabled) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        }, { capture: true, signal });
        this.observer = new MutationObserver(() => this.update());
        this.observer.observe(this.button, { attributes: true, attributeFilter: ['aria-busy'] });
        this.update();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
      }
      add(scent) {
        if (this.picks.length < this.count && this.canAdd(scent)) this.picks.push(scent);
        this.update();
      }
      remove(index) {
        if (index >= 0) this.picks.splice(index, 1);
        this.update();
      }
      // With no stock anywhere the builder stays explorable (the status says sold out); otherwise only
      // offer a scent if some in-stock bundle variant can still contain the picks plus that scent.
      canAdd(scent) {
        if (this.picks.length >= this.count) return false;
        if (!this.anyStock) return true;
        const want = [...this.picks, scent];
        return this.variants.some(v => {
          if (!v.available) return false;
          const left = v.key.split(' + ');
          return want.every(s => { const i = left.indexOf(s); if (i < 0) return false; left.splice(i, 1); return true; });
        });
      }
      update() {
        const busy = this.button.getAttribute('aria-busy') === 'true';
        const full = this.picks.length === this.count;
        const match = full ? this.variants.find(v => v.key === [...this.picks].sort().join(' + ')) : null;
        this.idInput.value = match?.available ? match.id : '';
        this.button.disabled = busy || !this.idInput.value;
        this.rows.forEach(row => {
          const scent = row.dataset.hfbScent;
          const qty = this.picks.filter(s => s === scent).length;
          row.toggleAttribute('data-picked', qty > 0);
          row.querySelector('[data-hfb-qty]').textContent = qty;
          const addable = !busy && this.canAdd(scent);
          row.querySelector('[data-hfb-add]').disabled = !addable;
          row.querySelector('[data-hfb-plus]').disabled = !addable;
          row.querySelector('[data-hfb-minus]').disabled = busy;
        });
        this.slots.forEach((slot, i) => {
          const scent = this.picks[i];
          const img = scent && this.rows.find(r => r.dataset.hfbScent === scent)?.dataset.img;
          slot.toggleAttribute('data-filled', !!scent);
          slot.disabled = busy || !scent;
          slot.title = scent || '';
          slot.innerHTML = '';
          if (img) {
            const el = document.createElement('img');
            el.src = img; el.alt = '';
            slot.append(el);
          } else {
            const el = document.createElement('span');
            el.textContent = scent ? scent[0] : i + 1;
            slot.append(el);
          }
          const prompt = this.getAttribute(`data-prompt-${i + 1}`);
          slot.setAttribute('aria-label', scent ? `${scent} (${prompt})` : prompt);
        });
        this.querySelector('[data-hfb-count]').textContent = `${this.picks.length} / ${this.count} ${this.dataset.chosen}`;
        const next = this.picks.length + 1;
        this.querySelector('[data-hfb-prompt]').textContent = full ? this.dataset.complete
          : this.getAttribute(`data-prompt-${next}`);
        this.querySelector('[data-hfb-status]').textContent = !this.anyStock ? this.dataset.soldOut
          : full && !match?.available ? this.dataset.unavailable : '';
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
